import { createContext } from 'react';

/** @type {any} */
const AppContext = createContext({
  app: {
    connected: true,
    offlineCapabilities: false,
    updateAvailable: false,
    updateSelected: false,
    loaded: false,
    locations: [],
    species: [],
    processes: [],
    weighInProcesses: [],
    options: [],
    recordLogs: false,
  },
  setApp: () => { }
})

export default AppContext